/*eslint-disable*/ export const messages = JSON.parse("{\"textfield.label.optional\":[\"Optional\"]}");
//# sourceMappingURL=messages.mjs.map